namespace TabAurous.ProductDevelopment {
    export namespace RequirementItemsService {
        export const baseUrl = 'ProductDevelopment/RequirementItems';

        export declare function Create(request: Serenity.SaveRequest<RequirementItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<RequirementItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<RequirementItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<RequirementItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CustomList(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<RequirementItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function RefNoList(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<RequirementItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function PDInterfaceList(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<RequirementItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function UpdateStatus(request: Serenity.SaveRequest<RequirementItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "ProductDevelopment/RequirementItems/Create",
            Update = "ProductDevelopment/RequirementItems/Update",
            Delete = "ProductDevelopment/RequirementItems/Delete",
            Retrieve = "ProductDevelopment/RequirementItems/Retrieve",
            List = "ProductDevelopment/RequirementItems/List",
            CustomList = "ProductDevelopment/RequirementItems/CustomList",
            RefNoList = "ProductDevelopment/RequirementItems/RefNoList",
            PDInterfaceList = "ProductDevelopment/RequirementItems/PDInterfaceList",
            UpdateStatus = "ProductDevelopment/RequirementItems/UpdateStatus"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'CustomList', 
            'RefNoList', 
            'PDInterfaceList', 
            'UpdateStatus'
        ].forEach(x => {
            (<any>RequirementItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
